import { NOMINATION_STATUS } from './constants';

export const filteringTableGetButtonIcon = (nominationStatusTypeId) =>
  nominationStatusTypeId === NOMINATION_STATUS.DRAFT
    ? 'bi bi-pen action-button'
    : 'bi bi-eye view-button';
